import React from 'react';

const Terms = () => {
  return (
    <div className="legal-page">
      <div className="legal-header">
        <h2>Terms & Conditions</h2>
        <p>Please read these terms and conditions carefully before using our service</p>
      </div>
      
      <div className="legal-content">
        <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>
        
        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            Welcome to Practice Talking. By accessing and using our platform, you agree to be bound by these Terms & Conditions. 
            If you do not agree to these terms, please do not use our services.
          </p>
        </section>

        <section>
          <h2>2. Description of Service</h2>
          <p>
            Practice Talking is an online platform that connects individuals seeking to improve their communication skills 
            ("Practitioners") with experienced conversation partners and experts ("Providers"). Our service facilitates:
          </p>
          <ul>
            <li>One-on-one conversation practice sessions</li>
            <li>Professional communication coaching</li>
            <li>Interview preparation</li>
            <li>Language practice and accent training</li>
            <li>Public speaking and presentation skills development</li>
          </ul>
        </section>

        <section>
          <h2>3. User Accounts and Registration</h2>
          <p>
            To use certain features of our platform, you must create an account. You agree to:
          </p>
          <ul>
            <li>Provide accurate, current, and complete information during registration</li>
            <li>Maintain and promptly update your account information</li>
            <li>Keep your login credentials secure and confidential</li>
            <li>Notify us immediately of any unauthorized use of your account</li>
            <li>Be responsible for all activities that occur under your account</li>
          </ul>
        </section>

        <section>
          <h2>4. User Conduct and Responsibilities</h2>
          <p>
            All users must conduct themselves professionally and respectfully. You agree not to:
          </p>
          <ul>
            <li>Use offensive, discriminatory, or inappropriate language</li>
            <li>Harass, threaten, or intimidate other users</li>
            <li>Share personal contact information outside the platform</li>
            <li>Record sessions without explicit consent from all participants</li>
            <li>Use the platform for illegal activities or commercial solicitation</li>
            <li>Impersonate others or provide false information</li>
          </ul>
        </section>

        <section>
          <h2>5. Provider Terms</h2>
          <p>
            Providers who offer services through our platform agree to:
          </p>
          <ul>
            <li>Accurately represent their qualifications and experience</li>
            <li>Provide services professionally and punctually</li>
            <li>Maintain appropriate boundaries with practitioners</li>
            <li>Comply with applicable laws regarding professional services</li>
            <li>Pay applicable platform fees and taxes</li>
          </ul>
        </section>

        <section>
          <h2>6. Payment and Fees</h2>
          <p>
            Our platform facilitates payments between practitioners and providers:
          </p>
          <ul>
            <li>Practitioners pay providers directly through our secure payment system</li>
            <li>Platform fees may apply to transactions</li>
            <li>Refund policies vary by provider and session type</li>
            <li>All fees are clearly disclosed before booking</li>
            <li>Payment disputes should be reported within 48 hours of the session</li>
          </ul>
        </section>

        <section>
          <h2>7. Cancellation and Rescheduling</h2>
          <p>
            Sessions may be cancelled or rescheduled subject to provider policies:
          </p>
          <ul>
            <li>Cancellation policies are set by individual providers</li>
            <li>Late cancellations may result in charges</li>
            <li>Technical issues may warrant session credits or refunds</li>
            <li>Repeated no-shows may result in account suspension</li>
          </ul>
        </section>

        <section>
          <h2>8. Privacy and Data Protection</h2>
          <p>
            We are committed to protecting your privacy. Please review our Privacy Policy for detailed information 
            about how we collect, use, and protect your personal data.
          </p>
        </section>

        <section>
          <h2>9. Intellectual Property</h2>
          <p>
            The Practice Talking platform, including its design, functionality, and content, is protected by intellectual property laws. 
            Users retain rights to their own content but grant us a license to operate the platform.
          </p>
        </section>

        <section>
          <h2>10. Limitation of Liability</h2>
          <p>
            Practice Talking serves as a platform connecting users. We are not liable for:
          </p>
          <ul>
            <li>The quality or outcomes of sessions between users</li>
            <li>Disputes between practitioners and providers</li>
            <li>Technical interruptions or platform downtime</li>
            <li>Loss of data or session recordings</li>
            <li>Actions or conduct of other users</li>
          </ul>
        </section>

        <section>
          <h2>11. Termination</h2>
          <p>
            We reserve the right to terminate or suspend accounts that violate these terms or engage in harmful behavior. 
            Users may also terminate their accounts at any time through their account settings.
          </p>
        </section>

        <section>
          <h2>12. Changes to Terms</h2>
          <p>
            We may update these Terms & Conditions periodically. Users will be notified of significant changes, 
            and continued use of the platform constitutes acceptance of updated terms.
          </p>
        </section>

        <section>
          <h2>13. Contact Information</h2>
          <p>
            If you have questions about these Terms & Conditions, please contact us through our 
            Help & Support page or email us at legal@practicetalking.com.
          </p>
        </section>

        <section>
          <h2>14. Governing Law</h2>
          <p>
            These terms are governed by applicable laws. Any disputes will be resolved through binding arbitration 
            in accordance with the rules of the applicable arbitration association.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Terms;